import { useCategoryContext } from '@/store/contexts/CategoryContext'

/**
 * Category 관련 Custom Hook
 * CategoryContext를 래핑하여 사용하기 편리하게 만듦
 */
export function useCategory() {
  return useCategoryContext()
}

